// needs to be a separate file from Toolbar to avoid circular imports between Toolbar <-> SavedReplies

import {forwardRef, useContext} from 'react'
import {MarkdownEditorContext} from './MarkdownEditorContext'
import {IconButton, type IconButtonProps} from '@primer/react'

export const ToolbarButton = forwardRef<HTMLButtonElement, IconButtonProps>((props, ref) => {
  const {disabled, condensed} = useContext(MarkdownEditorContext)

  return (
    <IconButton
      ref={ref}
      size={condensed ? 'small' : 'medium'}
      variant="invisible"
      disabled={disabled}
      // Prevent focus leaving input:
      onMouseDown={(e: React.MouseEvent) => e.preventDefault()}
      {...props}
      sx={{color: 'fg.muted', ...props.sx}}
    />
  )
})
ToolbarButton.displayName = 'MarkdownEditor.ToolbarButton'
